export const isEmail = (email) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  )
}

const formValidator = (inputs, setConfirm_password_error, setPassword_error, setLoginpassword) => {
  let validated = true

  Array.from(inputs).map((input) => {
    const { type, value, required, } = input
    const name = input.getAttribute('data-label')
      ? input.getAttribute('data-label')
      : input.name

    if (required) {
      if (value) {
        input.parentElement.getElementsByClassName('error-msg')[0].innerHTML =
          ''
      } else {
        validated = false
        input.parentElement.getElementsByClassName(
          'error-msg',
        )[0].innerHTML = `${name} cannot be blank`
      }
    }

    if (type === 'email') {
      if (isEmail(value)) {
        input.parentElement.getElementsByClassName('error-msg')[0].innerHTML =
          ''
      } else {
        validated = false
        input.parentElement.getElementsByClassName('error-msg')[0].innerHTML =
          'Invalid Email Address'
      }
    }
    if (input.name === 'confirm_password') {
      let password_confirmation = Array.from(inputs)[4].value
  
      if (value) {
        
        if (value != password_confirmation) {
          setConfirm_password_error(true)
          validated = false
        setConfirm_password_error(true)
          input.parentElement.getElementsByClassName(
            'error-msg',
          )[0].innerHTML = `Confirm password do not match with password`
        } else {
         setConfirm_password_error(false)
          input.parentElement.getElementsByClassName('error-msg')[0].innerHTML =
            ''
        }
      } else {
        setConfirm_password_error(true)
        input.parentElement.getElementsByClassName(
          'error-msg',
        )[0].innerHTML = `Password cannot be blank`
      }
    }
    if (input.name === 'password' ) {
      if (value) {
        if (value.length < 8) {
          validated = false
         setPassword_error(true)
          input.parentElement.getElementsByClassName(
            'error-msg',
          )[0].innerHTML = `Your password must be at least 8 character long`
        } else {
          setPassword_error(false)
          input.parentElement.getElementsByClassName('error-msg')[0].innerHTML =
            ''
        }
      } else {
         setPassword_error(true)
        input.parentElement.getElementsByClassName(
          'error-msg',
        )[0].innerHTML = `Password cannot be blank`
      }
    }
    return input
  })
  return validated
}

export default formValidator
